import React from 'react';
import clsx from 'clsx';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

// Only the grip starts a drag, so clicks on the row still open its editor.
export default function SortableBlock({
  id,
  data,
  disabled,
  border = true,
  borderTop = false,
  dropLine = null,
  children,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, data, disabled });

  const dragHandleProps = {
    ...attributes,
    ...listeners,
    ref: setActivatorNodeRef,
    'aria-label': 'Drag to move',
    'data-drag-handle': id,
  };

  return (
    <div
      ref={setNodeRef}
      data-sortable-id={id}
      style={{ transform: CSS.Translate.toString(transform), transition }}
      className={clsx('relative bg-white dark:bg-background', {
        'border-b border-gray-200 dark:border-border': border,
        'border-t border-gray-200 dark:border-border': borderTop,
        'opacity-40': isDragging,
      })}
    >
      {/* Above the drag overlay (z-index 999), which covers the line wherever the pointer is. */}
      {dropLine && (
        <div
          aria-hidden="true"
          data-drop-line={dropLine}
          className={clsx(
            'pointer-events-none absolute inset-x-1 z-[1000] h-0.5 rounded-full bg-foreground',
            {
              '-top-px': dropLine === 'before' && border,
              '-bottom-px': dropLine === 'after' && border,
              '-top-1.5': dropLine === 'before' && !border,
              '-bottom-1.5': dropLine === 'after' && !border,
            },
          )}
        />
      )}
      {children({ dragHandleProps, isDragging })}
    </div>
  );
}
